import styled from 'styled-components';

export const StyledBannerContent = styled.div(({ theme }) => `
  display: flex;

  .logo {
    width: 60px;
    height: 60px;
    margin-right: ${theme.uptimeSpace[6]}px;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
`);
